import React from 'react';

interface EmailRowProps {
  subject: string;
  preview: string;
  index: number;
}
const avatar =
  'https://storage.googleapis.com/mavid-311321.appspot.com/maverick-brand-assets/optimizer-robot-avatar.png';
const EmailRow: React.FC<EmailRowProps> = ({
  subject,
  preview,
  index,
}: {
  subject: string;
  preview: string;
  index: number;
}) => {
  return (
    <tr className='cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700'>
      <td className='py-4 pl-6 pr-10'>
        <div className='flex items-center'>
          <img className='mr-3 size-8 rounded-full' src={avatar} alt={`avatar for ${index}`} />
          <div>
            <div className=' text-gray-900 dark:text-white'>{`Option ${index + 1}`}</div>
          </div>
        </div>
      </td>

      <td className='p-2'>
        <div className='flex items-center space-x-2'>
          <div className='flex items-center gap-2'>
            <p className='max-w-md truncate font-semibold text-gray-900 dark:text-white'>{subject}</p>
          </div>
          <div className='text-gray-300 dark:text-gray-600'>—</div>
          <div className='flex items-center gap-2'>
            <p className='max-w-md truncate text-gray-400 dark:text-gray-500'>{preview}</p>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default EmailRow;
